/**
 * Type definitions for component methods to avoid absolute paths in components.d.ts
 */

export interface CameraInfoResponse {
  availableCameras: Array<{ id: string; label: string; selected: boolean }>;
  selectedCameraId: string | null;
  deviceType: string;
  isMultipleCamerasAvailable: boolean;
  preferredFacing: 'environment' | 'user' | null;
  error?: string;
}

export interface CapturedImagesResponse {
  front: {
    fullFrame: string | null;
    cropped: string | null;
  };
  back: {
    fullFrame: string | null;
    cropped: string | null;
  };
  metadata: {
    totalImages: number;
    processCompleted: boolean;
    backCaptureSkipped: boolean;
  };
}


export interface StatusResponse {
  isVideoActive: boolean;
  captureStep: 'front' | 'back' | 'completed';
  hasImages: boolean;
  isProcessCompleted: boolean;
  isModelPreloaded: boolean;
  componentStatus?: 'initializing' | 'loading' | 'ready' | 'error';
  componentMessage?: string;
}